export default __webpack_public_path__ + "static/media/photo--sm--57.3b7abc28.jpg";